import {context} from '../constants/context';
import {halClient} from '../hal';
import {BBModel} from '../bb_model';

const company = {

    async query(companyId, options = {}) {
        const root = options.root || context.apiUrl;
        const excludeChildCompanies = options.excludeChildCompanies ? '?embed=no_child_companies' : '';

        const url = `${root}/api/${context.apiVersion}/company/${companyId}${excludeChildCompanies}`;

        const company = await halClient.$get(url, options);
        return new BBModel.Company(company);
    },

    async queryByRef(reference, options = {}) {
        const root = options.root || context.apiUrl;
        const excludeChildCompanies = options.excludeChildCompanies ? '?embed=no_child_companies' : '';

        const url = `${root}/api/${context.apiVersion}/company/find_by_ref/${reference}${excludeChildCompanies}`;
        try {
            const company = await halClient.$get(url, options);
            return new BBModel.Company(company);
        } catch (ignored) {
            throw new Error('Invalid Company Reference: ' + reference);
        }
    },

    queryChildren(company) {
        return new Promise((resolve, reject) => {
            if (!company.$has('companies')) {
                reject('No child companies found');
            } else {
                company.$get('companies').then((resource) => {

                        return resource.$get('companies').then((items) => {
                                const companies = [];
                                for (const i of Array.from(items)) {
                                    companies.push(new BBModel.Company(i));
                                }
                                return resolve(companies);
                            }
                        );
                    }
                    , (err) => {
                        return reject(err);
                    }
                );
            }
        });
    },

    queryByCoords(company_id, options) {
        options.root = options.root || context.apiUrl;
        options.coords = options.coords || null;
        options.radius = options.radius || null;

        if (options.coords === null) {
            console.error('Make sure you passed the options.coords parameter');
            return false;
        }
        let url = options.root + `/api/${context.apiVersion}/company/` + company_id + '/search?address[lat]=' + options.coords.lat + '&address[long]=' + (options.coords.lng || options.coords.long);
        if (options.admin) {
            url = options.root + `/api/${context.apiVersion}/admin/` + company_id + '/company/search?address[lat]=' + options.coords.lat + '&address[long]=' + (options.coords.lng || options.coords.long);
        }

        if (options.radius) {
            url += `&address[radius]=${options.radius}`;
        }
        if (options.page) {
            url += `&page=${options.page}`;
        }
        if (options.per_page) {
            url += `&per_page=${options.per_page}`;
        }
        if (options.service_id) {
            url += `&service_id=${options.service_id}`;
        }

        return new Promise((resolve, reject) => {
            halClient.$get(url, options).then((collection) => {
                    collection.$get('companies').then((resources = []) => {
                        const companies = resources.map((resource) => {
                            return Object.assign(new BBModel.Company(resource), {
                                address: new BBModel.Address(resource.address)
                            });
                        });

                        return resolve({ companies, links: collection.$links() });
                    });
                }
                , (err) => {
                    return reject(err);
                }
            );

        });
    },

    queryByText(company_id, options) {
        return new Promise((resolve, reject) => {
            options.root = options.root || context.apiUrl;
            options.text = options.text || null;

            if (options.text === null) {
                console.error('Make sure you passed the option.text parameter');
                reject([]);
            }

            let url = options.root + `/api/${context.apiVersion}/company/` + company_id + '/search?company[text]=' + encodeURI(options.text);
            if (options.admin) {
                url = options.root + `/api/${context.apiVersion}/admin/` + company_id + '/company/search?company[text]=' + encodeURI(options.text);
            }


            if (options.service_id) {
                url += `&service_id=${options.service_id}`;
            }

            halClient.$get(url, options).then((resource) => {
                    resource.$get('companies').then((items) => {
                        const companies = [];
                        for (const i of Array.from(items)) {
                            companies.push(new BBModel.Company(i));
                        }
                        return resolve(companies);
                    });
                }
                , (error) => {
                    console.error(error);
                    return reject([]);
                }
            );
        });
    },

    queryByService(companyId, { root = context.apiUrl, serviceId }) {
        const url = root + `/api/${context.apiVersion}/company/${companyId}/search?service_id=${serviceId}`;

        return halClient.$get(url, { root }).then((resource) => {
            return resource.$get('companies').then((items) => {
                const companies = [];
                for (const i of Array.from(items)) {
                    companies.push(new BBModel.Company(i));
                }
                return Promise.resolve(companies);
            });
        }
        , (error) => {
            console.error(error);
            return Promise.reject([]);
        }
    );
    }

};

export {
    company
};
